export default __webpack_public_path__ + "static/media/universe-4609408.93fbf14b.jpg";